
import React from 'react';

export default class AppInfo extends React.Component {
    render() {
        return (<div className={`fill ${ this.props.className }`}></div>);
    }
};


// WEBPACK FOOTER //
// ./src/components/Headers/FillRow.js